<template lang='pug'>
  blue-layout( v-if='user' :user='user' :account='account' :biz='biz' )
    #profile.view
      bf-notice(:message='message' @close='message = ""')

      transition(name='flip')
        bf-wrapper.max-640
          form.profile-form( @submit.prevent='set' )
            bf-flex.avatar.centered(@click.native='$refs.upload.click()')
              input( type='file' ref='upload' style='display: none' accept='image/*' @change='upload( $event, "avatar" )' )
              template( v-if='doc.avatar || account.avatar' )
                .image-container.actionable
                  img( :src='doc.avatar || account.avatar' )
              template( v-else )
                bf-flex.upload-container.centered.actionable
                  img( :src='doc.avatar || "/ui/profile.png"' )
                  span {{ $t('Add Image') }}

            .fields
              fieldset.span-1
                label {{$t("Gender")}} *
                bf-input.gender.basic
                  select( v-model='doc.gender' required )
                    option(value='male') {{ $t('Male') }}
                    option(value='female') {{ $t('Female') }}

              fieldset.span-1
                label {{$t("Site Language")}}
                bf-input.locale.basic
                  select(v-model='doc.locale')
                    option(value='en') English
                    option(value='es') Español
                    option(value='ch') 中文

              fieldset.span-2
                label {{$t("Zip Code")}}*
                bf-input.zip.basic
                  input( v-model='doc.zip' type='zip' :placeholder='$t("Zip Code")' required )
                

            bf-divider.borderless.section

            .fields
              fieldset.span-2
                label {{$t("Phone (Mobile)")}}*
                bf-input.phone-mbl.basic
                  input( type='phone' :placeholder='$t("Phone (Mobile)")' v-model='doc.phone' required )

              .span-2.dob
                label {{$t("Birthday (Year optional)")}}

                .dob-fields
                  .field.month
                    label {{$t("Month")}}*
                    bf-input.basic
                      input( type='number' v-model='dob.month' required min='1' max='12')

                  .field.date
                    label {{$t("Day")}}*
                    bf-input.basic
                      input( type='number' v-model='dob.date' required min='1' max='31' )
                    
                  .field.year
                    label {{$t("Year")}}
                    bf-input.basic
                      input( type='number' v-model='dob.year' )

            bf-divider.section

            .auth-fields.fields
              fieldset.span-4( v-if='!user.email' )
                label {{$t("Email")}}*
                bf-input.username.basic( :class='{ remind: !doc.email }' )
                  input( type='email' :placeholder='$t("Email")' required v-model='doc.email' ref='email' )

              fieldset.span-4
                label {{$t("Username")}}*
                bf-input.username.basic( :class='{ remind: !doc.username }' )
                  input( type='text' :placeholder='$t("Username")' required v-model='doc.username' ref='username' )

            bf-divider.section

            bf-flex.centered.save-button-wrapper
              bf-button(type='submit')
                template(v-slot:text) {{ $t('Next') }}

              bf-button.cancel(type='reset')
                template(v-slot:text) {{ $t('Clear') }}
</template>

<script>
  import { auth, db, firebase, str } from '@/main'
  import { View, Animatable } from '@/mixins/view'
  import ProfileHeader from '@/components/profile-header'

  export default {
    name: 'new-profile.view',

    components: {
      ProfileHeader
    },

    props: ['user', 'account'],

    mixins: [ View, Animatable ],

    data() {
      return {
        type: 'Account',
        collection: 'accounts',
        password: {},
        message: '',
        ready: false,
        prompt: false,
        invalid: false,
        doc: { hours: {} },
        dob: {},
        key: 0
      }
    },

    watch: {
      account( curr, prev ) {
        if ( curr.id ) {
          this.doc = curr
          this.dob = curr.dob || {}
        }
      }
    },

    methods: {
      linked( usr ) {
        this.key++
      },

      upload( e, field ) {
        let reader  = new FileReader()
        reader.addEventListener('load', () => {
          const name = file.name
          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            let width = img.width
            let height = img.height
            let ratio = img.width / img.height
            if( img.width > 100 ) {
              width = 100
              height = width / ratio
            }
            else if ( img.height > 100 ) {
              height = 100
              width = height * ratio
            }
            const elem = document.createElement('canvas')
            elem.width = width
            elem.height = height
            const ctx = elem.getContext('2d')
            ctx.drawImage( img, 0, 0, width, height )
            ctx.canvas.toBlob( blob => {
              const file = new File([blob], name, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })

              let ref = str.ref( `/user/${this.user.uid}/logos/${file.name}` )
              ref.put(file).then( snap => {
                snap.ref.getDownloadURL().then( url => {
                  this.$set(this.doc, field, url)
                })
              }).catch( e => console.log(e) )
            }, 'image/jpeg', 1)
          }
          
        }, false)

          
        let file = e.target.files[0]
        if (file) reader.readAsDataURL(file)
      },

      async set() {
        let snap = await db.collection('accounts').where( 'username', '==', this.doc.username ).get()
        let accounts = snap.docs
        let exists = accounts.find( a => a.data().username == this.doc.username && a.id != this.doc.id  )
        if ( exists ) {
          this.message = this.$t('Username must be unique')
          this.doc.username = ''
          this.$refs.username.focus()
        }
        else {
          let idref = db.collection( this.collection ).doc( this.user.uid )
          let saveable = { dob: this.dob, email: this.user.email, ...this.doc }
          idref.set( saveable, { merge: true } ).then( () => {
            if ( ![ 'facebook.com', 'phone' ].some( id => this.user.providerData.map( d => d.providerId ).includes( id ) ) )
              this.$router.push({ name: 'verify-email', params: { id: this.doc.id } })
            else
              this.$router.push({ name: 'welcome', params: { modals: 'to-bluefaucet' } })
          })
        }
      },

      acknowledge() {
        this.modal.show = false
      },

      join() {
        this.doc.merchant = 'basic'
        this.set()
        this.$router.push({ name: 'business-profile', params: { thanks: true } })
      },

      skip() {
        this.$router.push({ name: 'welcome' })
        this.modal.show = false
      }
    },

    created() {
      if ( this.account.id ) this.dob = this.account.dob || {}
    }
  }
</script>

<style scoped lang='stylus'>
  #profile.view
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type=number] {
      text-align center
      -moz-appearance: textfield;
    }
    
    .fields
      display grid
      grid-gap 16px
      grid-template-columns 1fr 1fr 1fr 1fr 
      &.address
        grid-template-columns 1fr 1fr 1fr
      @media( max-width: 640px )
        grid-template-columns 1fr 1fr
        .span-1, .span-2, .span-3, .span-4
          grid-column 1 / -1
      .span-2
        grid-column span 2
      .span-3
        grid-column span 3
      .span-4
        grid-column span 4
    
    fieldset .bf-input
      margin-top 8px
    
    .invalid .bf-input >>> .container
      border-color red
      background rgb( 250 240 240 )

    label 
      font-weight bold

    .dob-fields
      margin-top 8px
      display flex
      justify-content space-between

      label, .bf-input
        display inline-block
      label
        margin-right 8px
        font-weight normal
        color rgb( 128 128 128 )
      input
        width 20px
      .field.year input
        width 36px

  .save-button-wrapper .bf-button
    margin 0 12px

  .avatar
    margin 24px 0 16px 0
    .image-container
      width 88px
      height 88px
      img
        width 100%
        height 100%
        object-fit cover
        border-radius 50%
    .upload-container
      width 88px
      height 88px
      flex-direction column
      background rgb( 240 240 250 )
      border-radius 50%
      img
        width 20px
      span
        font-size .88em
        margin 8px 0
        font-weight bold

  h6
    padding 4px
    font-weight bold

  .forgot-password-link
    display block
    text-align right
    padding 8px 16px
    font-weight bold
    color var(--clr-blue)

  #modal
    position fixed
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 99
    background white
    align-items flex-start
    flex-direction column
    .close
      position absolute
      color white
      font-size 1.5em
      border 1px solid var(--clr-light)
      height 24px
      width 28px
      padding-bottom 4px
      display flex
      justify-content center
      border-radius 50%
      right 12px
      top 12px
    header
      position relative
      text-align center
      background var(--bg-nav)
      color white
      width 100%
      margin-bottom 24px
      padding 16px 0
      .heading
        color white
      img
        height 24px
    main
      width 320px
      margin 0 auto

  .bf-button.bright.wide
    margin 12px
</style>
